import { css } from '@emotion/react'
import { rem } from '@groovehq/internal-design-system/lib/util'
import inbox from 'assets/groove-inbox.jpg'

const header = theme => css`
  border-bottom: 1px solid rgba(${theme.color.monochrome.black_rgba}, 0.1);
  display: flex;
  justify-content: center;
  padding-bottom: ${rem(32)};

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    padding-bottom: ${rem(24)};
  }
`

const logo = theme => css`
  height: ${rem(40)};

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    height: ${rem(30)};
  }

  img {
    height: 100%;
    width: auto;
  }
`

const login = theme => css`
  font-size: ${theme.fontSize.x2large};
  color: rgba(${theme.color.monochrome.black_rgba}, 0.6);
  display: flex;
  justify-content: center;

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    font-size: ${theme.fontSize.small};
  }
`

const loginLink = theme => css`
  color: ${theme.color.primary.info};
  font-weight: ${theme.fontWeight.medium};

  &:hover {
    color: ${theme.color.info['600']};
    text-decoration: underline;
  }
`

const panel = theme => css`
  font-family: ${theme.font.tertiary};
  width: 100%;
  max-width: ${rem(600)};
  padding: ${rem(40)};
  border-radius: ${rem(16)};
  box-shadow: 0px 200px 80px 0px
      rgba(${theme.color.monochrome.black_rgba}, 0.01),
    0px 113px 68px 0px rgba(${theme.color.monochrome.black_rgba}, 0.03),
    0px 50px 50px 0px rgba(${theme.color.monochrome.black_rgba}, 0.04),
    0px 13px 27px 0px rgba(${theme.color.monochrome.black_rgba}, 0.05);
  .signupVerification {
    margin: ${rem(60)} auto ${rem(40)};
  }
`

const bgImage = css`
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;

  img {
    width: 100%;
  }
`

const backdrop = theme => css`
  background: transparent url(${inbox}) no-repeat top center/cover;
  z-index: 999;

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    background-position: top left;
    background-size: 656px;
  }

  & + [role='dialog'] {
    z-index: 1000;
    padding: ${rem(20)};
    overflow-x: hidden;
  }
`

const copy = theme => css`
  color: ${theme.color.monochrome.superDark};
  font-size: ${theme.fontSize.large};
  position: absolute;
  bottom: ${rem(-136)};
  text-align: center;

  @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
    font-size: ${theme.fontSize.small};
    max-width: ${rem(292)};
  }

  a {
    color: ${theme.color.primary.info};

    &:hover {
      color: ${theme.color.info['600']};
    }
  }
`

// blob
const blob = theme => css`
  @supports (filter: blur(100px)) or (-webkit-filter: blur(100px)) {
    &::before {
      content: '';
      display: block;
      position: absolute;
      background-color: ${theme.color.primary.info};
      width: ${rem(448)};
      height: ${rem(334)};
      filter: blur(200px);
      pointer-events: none;
      z-index: -1;
      border-radius: ${rem(500)};

      @media only screen and (max-width: ${theme.breakpoints
          .tabletBreakpoint}) {
        width: ${rem(224)};
        height: ${rem(167)};
        border-radius: ${rem(250)};
        filter: blur(100px);
      }
    }
  }
`

const blob1 = theme => css`
  ${blob(theme)};
  &::before {
    top: ${rem(-78)};
    right: ${rem(-220)};
    background-color: #128ecc;

    @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
      top: ${rem(42)};
      right: ${rem(-100)};
    }
  }
`

const blob2 = theme => css`
  ${blob(theme)};
  &::before {
    top: ${rem(59)};
    left: ${rem(-220)};
    background-color: #ff0e56;

    @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
      top: ${rem(110)};
      left: ${rem(-100)};
    }
  }
`

const blob3 = theme => css`
  ${blob(theme)};
  &::before {
    bottom: 0;
    left: ${rem(70)};

    @media only screen and (max-width: ${theme.breakpoints.tabletBreakpoint}) {
      bottom: ${rem(42)};
      left: ${rem(45)};
    }
  }
`

export const styles = {
  header,
  logo,
  login,
  panel,
  bgImage,
  backdrop,
  loginLink,
  copy,
  blob1,
  blob2,
  blob3,
}
